var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.invisible)?_c('div',{staticClass:"ads"},[_c('button',{staticClass:"close",on:{"click":_vm.handleClose}},[_vm._v("✕")]),_c('router-link',{attrs:{"to":"/c/all?type=rank&tab=teacher"}},[_c('img',{attrs:{"src":"/img/ads_top.png"}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }